import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { useStyles } from "../../../assets/jss/Dialog";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import CustomDialog from "../../CustomComponents/CustomDialog/CustomDialog";
import CustomDialogContent from "../../CustomComponents/CustomDialogContent/CustomDialogContent";
import CustomDialogAction from "../../CustomComponents/CustomDialogAction/CustomDialogAction";
import lockIcon from "../../../assets/images/lock_Medium.png";
import CustomBox from "../../CustomComponents/CustomBox/CustomBox";
import CustomButton from "../../CustomComponents/CustomButton/CustomButton";
import CustomTextField from "../../CustomComponents/CustomTextField/CustomTextField";
import { useTranslation } from "react-i18next";
import { IsUserAccountLocked } from "../../../config/app-globals.enum";
const styles = (theme) => ({});

const DialogContent = withStyles((theme) => ({}))(CustomDialogContent);

const DialogActions = withStyles((theme) => ({}))(CustomDialogAction);

export default function UnlockUserDialog(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const [open, setOpen] = React.useState(props.dialogOpen);
  const [userName, setUserName] = React.useState(null);
  const handleClose = (confirmDelete) => {
    setOpen(false);
    props.dialogClose(false, confirmDelete);
  };

  React.useEffect(() => {
    setOpen(props.dialogOpen);
  }, [props.dialogOpen]);

  return (
    <CustomDialog
      onClose={() => handleClose(false)}
      aria-labelledby="customized-dialog-title"
      open={open}
      className={classes.dialogWrapper}
    >
      <IconButton
        aria-label="close"
        className={classes.closeButton}
        onClick={() => handleClose(false)}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent className={classes.dialogContentWrapper}>
        <CustomBox className={classes.dialogContentIcon}>
          <img src={lockIcon} />
        </CustomBox>
        <Typography className={classes.dialogContentTitle}>
          {props.isAccountLocked === IsUserAccountLocked.LOCKED ? t("ARE_YOU_SURE_YOU_WANT_TO_UNLOCK")
          :t("ARE_YOU_SURE_YOU_WANT_TO_LOCK")}{props.userName.firstName+" "+props.userName.lastName}
        </Typography>
      </DialogContent>
      <DialogActions className={classes.dialogActionWrapper}>
        <CustomButton
          autoFocus
          onClick={() => handleClose(false)}
          color="primary"
          className={classes.noBg}
        >
          {t("CANCEL")}
        </CustomButton>
        <CustomButton
          autoFocus
          onClick={() => handleClose(true)}
          variant="contained"
          color="secondary"
          defaultrounded="true"
        >
          {props.isAccountLocked === IsUserAccountLocked.LOCKED ? t("UNLOCK_USER")
          :t("LOCK_USER")}
        </CustomButton>
      </DialogActions>
    </CustomDialog>
  );
}
